import {
  StyledGridLabelValue,
  StyledRowItemsWrapper,
  StyledTd,
} from '@/components/sections/service/maintenance-list/table/full';
import { StyledScrollSnapWrapper } from '@/components/sections/service/maintenance-list/table/full/scrollbar';
import { Icon } from '@/components/shared/element/icons';
import { Text } from '@/components/shared/element/text';
import { Box } from '@/components/shared/layout/box';
import { Flex } from '@/components/shared/layout/flex';
import { getPriceFormat } from '@/contents/useMaintenanceList';
import {
  MaintenanceCostKey,
  RegularMaintenaceSchedule,
} from '@/types/services/contentstack/services/maintenance-service';
import { IIcon } from '@/types/shared';

interface MaintenanceListTableFullTfootProps {
  costBeforeVatTitle?: string;
  discountTitle?: string;
  totalCostWithVatTitle?: string;
  costBeforeVatIcon?: IIcon;
  discountIcon?: IIcon;
  totalCostWithVatIcon?: IIcon;
  maintenanceSchedules: RegularMaintenaceSchedule[];
  selectedIndex?: number;
}

export const MaintenanceListTableFullTfoot = (
  props: MaintenanceListTableFullTfootProps
) => {
  return (
    <Box
      marginTop="4"
      css={{
        borderBottomLeftRadius: '$rounded-2',
        borderBottomRightRadius: '$rounded-2',
      }}
      overflow="hidden"
      test={{
        dataTest: 'maintenance_tableFooter',
      }}
    >
      <StyledGridLabelValue backgroundColor="gray200">
        <StyledTd isLabel>
          <Flex alignItems="center" columnGap="2">
            <Icon icon={props.costBeforeVatIcon} size="sm" />
            <Text as="p" font="bold">
              {props.costBeforeVatTitle}
            </Text>
          </Flex>
        </StyledTd>
        <StyledScrollSnapWrapper>
          <StyledRowItemsWrapper className="scrollable-area">
            {props.maintenanceSchedules.map((schedule, index) => (
              <StyledTd
                key={`${MaintenanceCostKey.CostBeforeVat}${schedule.month}`}
                isTableValueCell
                align="center"
                isActive={index === props.selectedIndex}
              >
                <Text as="span" variant="text-current">
                  {getPriceFormat({
                    price: schedule[MaintenanceCostKey.CostBeforeVat],
                  })}
                </Text>
              </StyledTd>
            ))}
          </StyledRowItemsWrapper>
        </StyledScrollSnapWrapper>
      </StyledGridLabelValue>
      <StyledGridLabelValue backgroundColor="white">
        <StyledTd isLabel>
          <Flex alignItems="center" columnGap="2">
            <Icon icon={props.discountIcon} size="sm" color="icon-red" />
            <Text as="p" font="bold" variant="text-red">
              {props.discountTitle}
            </Text>
          </Flex>
        </StyledTd>
        <StyledScrollSnapWrapper>
          <StyledRowItemsWrapper className="scrollable-area">
            {props.maintenanceSchedules.map((schedule, index) => (
              <StyledTd
                key={`${MaintenanceCostKey.Discount}${schedule.month}`}
                isTableValueCell
                align="center"
                isActive={index === props.selectedIndex}
              >
                <Text as="span" font="bold" variant="text-red" noWrap>
                  {schedule.discount_coupon
                    ? schedule.discount_coupon
                    : getPriceFormat({
                        price: schedule[MaintenanceCostKey.Discount],
                        isDiscount: true,
                      })}
                </Text>
              </StyledTd>
            ))}
          </StyledRowItemsWrapper>
        </StyledScrollSnapWrapper>
      </StyledGridLabelValue>
      <StyledGridLabelValue backgroundColor="gray800">
        <StyledTd isLabel>
          <Flex alignItems="center" columnGap="2">
            <Icon
              icon={props.totalCostWithVatIcon}
              size="sm"
              color="icon-white"
            />
            <Text as="p" font="bold" variant="text-white">
              {props.totalCostWithVatTitle}
            </Text>
          </Flex>
        </StyledTd>
        <StyledScrollSnapWrapper>
          <StyledRowItemsWrapper className="scrollable-area">
            {props.maintenanceSchedules.map((schedule, index) => (
              <StyledTd
                key={`${MaintenanceCostKey.TotalCostWithVat}${schedule.month}`}
                isTableValueCell
                align="center"
                backgroundColor={
                  index === props.selectedIndex ? 'red' : undefined
                }
              >
                <Text as="span" font="bold" variant="text-white" noWrap>
                  {getPriceFormat({
                    price: schedule[MaintenanceCostKey.TotalCostWithVat],
                  })}
                </Text>
              </StyledTd>
            ))}
          </StyledRowItemsWrapper>
        </StyledScrollSnapWrapper>
      </StyledGridLabelValue>
    </Box>
  );
};
